export const globalErrorHandler = (error, componentStack) => {
  if (window.__ROLLBAR_CONFIG__ && Rollbar) {
    Rollbar.log(error);
  }
};
